var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-tickets"},[_c('b-button-group',{staticClass:"mt-4 mb-0"},_vm._l((_vm.items),function(ref){
var key = ref[0];
var val = ref[1];
return _c('b-button',{key:key,class:{ active: val === _vm.value },attrs:{"variant":"outline-primary"},on:{"click":function($event){return _vm.$emit('input', val)}}},[_vm._v("\n      "+_vm._s(key)+"\n    ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }